import React, { useEffect, useState } from 'react';
import { SurveyExerciseProps } from './types';
import Collapse from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import { Grid, Paper } from '@mui/material';
import Question from '../QuestionAndAnswer/Question';
import { autoId } from '../../utils/UidGenerator';
import { Button } from '@mui/material';
import { Task } from '../../store/tasks/types';

const SurveyExercise: React.FC<SurveyExerciseProps> = (props) => {
    const [expanded, setExpanded] = useState(false);

    const createNewItem = () => {
        const taskId = autoId();
        props.setExercises(
            props.exercises.map((exercise) =>
                exercise.id !== props.currentExercise.id
                    ? exercise
                    : {
                          ...props.currentExercise,
                          tasks: !props.currentExercise.tasks ? [taskId] : [...props.currentExercise.tasks, taskId],
                      },
            ),
        );
        return { id: taskId, type: props.taskType, image: '', description: {} } as Task;
    };

    useEffect(() => {
        if (props.tasksData.length > 0) props.setTasks(props.tasksData);
    }, [props.tasksData]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleClick = () => {
        props.setTasks([...props.tasks, createNewItem()]);
    };

    return (
        <div className="survey-exercise">
            <Grid container>
                <Grid item xs={6}>
                    <div className="survey-exercise-row">
                        {props.name?.[props.language]}
                        <div className="survey-exercise-row-expand">
                            <IconButton onClick={handleExpandClick}>
                                <ExpandMoreIcon style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }} />
                            </IconButton>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Paper className="exercise-paper" elevation={2}>
                            {props.tasks
                                .filter((task) => props.currentExercise.tasks?.includes(task.id))
                                .map((task) => {
                                    return (
                                        <Question
                                            key={task.id}
                                            id={task.id}
                                            language={props.language}
                                            languages={props.languages}
                                            skills={props.skills}
                                            tasks={props.tasks}
                                            setTasks={props.setTasks}
                                        ></Question>
                                    );
                                })}
                            <Grid item xs={12} justifyContent="left">
                                <Button className="add-question-btn" variant="outlined" onClick={handleClick}>
                                    Add question
                                </Button>
                            </Grid>
                        </Paper>
                    </Collapse>
                </Grid>
            </Grid>
        </div>
    );
};

export default SurveyExercise;
